import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { semanticColors, foundations } = capitalDesignTokens;
const { semiBold } = foundations.typography.fontWeight;
const { secondary } = semanticColors.foreground;

export const styles = createTypedSxStyles({
  controls: {
    display: "flex",
    alignItems: "flex-end",
    gap: "8px",
    paddingBottom: "24px",
    flexWrap: "wrap",
    "& .MuiInputBase-root.MuiOutlinedInput-root": {
      margin: "0px",
    },
  },
  searchField: {
    flex: 1,
    minWidth: "120px",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    position: "relative",
    flexShrink: 0,
  },
  label: {
    display: "block",
    fontSize: "11px",
    fontWeight: semiBold,
    color: secondary,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    margin: "0px",
    lineHeight: "16px",
  },
  hide: {
    display: "none",
  },
  srOnly: {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0px",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: "0px",
  },
});
